import { Ref } from 'vue';
import { PlanStore, PlanStoreInterface } from '@/planList/infrastructure/store/PlanStore';
import { usePlocState, getStore } from '@hfc/ui-core';

interface UsePlanStoreInterface {
  planStore: PlanStore;
  planState: Ref<PlanStoreInterface>;
}

export const usePlanStore = (): UsePlanStoreInterface => {
  const planStore = getStore<PlanStore>('PlanStore', PlanStore);
  const planState = usePlocState(planStore) as Ref<PlanStoreInterface>;

  return {
    planStore,
    planState,
  };
};
